export * as yup from 'yup';

export const getRandomColor = () =>
  `#${Math.floor(Math.random() * 16777215).toString(16)}`;

export const getRandomLightColor = () => {
  const red = Math.floor(Math.random() * 255);
  const green = Math.floor(Math.random() * 255);
  const blue = Math.floor(Math.random() * 255);
  const opacity = 0.5;
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

export function randomBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const extractColor = (colorString: string) => {
  return colorString.split(';')[0];
};

export function omit<T extends Record<string, any>, K extends keyof T>(
  object: T,
  keys: K[],
): Omit<T, K> {
  return keys.reduce((acc: any, curr) => {
    const { [curr]: _omitted, ...rest } = acc;
    return rest;
  }, object as T);
}
